export const Logo = ({ flagClass = "h-8", boxed = false, variant = "compact" }) => {
  const src = variant === "full" ? "/logo-full.png" : "/logo-compact.png";
  const img = (
    <img src={src} alt="RenovBreizh" className={`${flagClass} w-auto object-contain`} data-testid="brand-logo" />
  );
  if (boxed) {
    return <div className="inline-flex items-center bg-white rounded-lg px-2.5 py-1.5 shadow-sm">{img}</div>;
  }
  return img;
};

export default Logo;
